import {
  IconDashboard,
  IconBuildingBank,
  IconUsers,
  IconUserCheck,
  IconUserCircle,
  IconCreditCard,
  IconFileDollar,
  IconBusinessplan,
  IconChartPie,
  IconCut,
  IconBuilding,
  IconCash,
  IconBuildingSkyscraper,
  IconWallet,
  IconUser,
  IconZoomMoney,
  IconSend,
} from "@tabler/icons";

const navConfig = [
  {
    title: "Dashboard",
    path: "/admin/dashboard",
    icon: <IconDashboard stroke={1.5} size={20} />,
  },
  {
    title: "Admin List",
    path: "/admin/list",
    icon: <IconUser stroke={1.5} size={20} />,
  },
  {
    title: "Account",
    path: "/account/list",
    icon: <IconBuildingBank stroke={1.5} size={20} />,
  },
  {
    title: "Person",
    path: "/person/list",
    icon: <IconUsers stroke={1.5} size={20} />,
  },
  {
    title: "Directors",
    icon: <IconUserCircle stroke={1.5} size={20} />,
    children: [
      {
        title: "Director List",
        path: "/director/list",
      },
      {
        title: "Remuneration",
        path: "/director/remuneration",
      },
      {
        title: "Eid Bonus",
        path: "/director/eid-bonus",
      },
      {
        title: "Honorarium",
        path: "/director/honorarium",
      },
      {
        title: "Construction Charges",
        path: "/director/construction-charge",
      },

      {
        title: "Land Profit",
        path: "/director/land-profit",
      },
    ],
  },
  {
    title: "Projects",
    icon: <IconBuildingSkyscraper stroke={1.5} size={20} />,
    children: [
      {
        title: "Project List",
        path: "/project/list",
      },
      {
        title: "Expense Unit",
        path: "/project/expense-unit",
      },
      {
        title: "Land Expense Category",
        path: "/project/land/expense-category",
      },
      {
        title: "Report Expense Category",
        path: "/project/report-expense-category",
      },
      {
        title: "Project Expense Category",
        path: "/project/expense-category",
      },
    ],
  },
  {
    title: "Investor",
    icon: <IconBusinessplan stroke={1.5} size={20} />,
    children: [
      {
        title: "Investor List",
        path: "/investor/list",
      },
      {
        title: "Investment",
        path: "/investor/investment",
      },
      {
        title: "Investment Return",
        path: "/investor/return-investment",
      },
    ],
  },
  {
    title: "Short Term Loan",
    icon: <IconFileDollar stroke={1.5} size={20} />,
    children: [
      {
        title: "Loan Person",
        path: "/loan/person",
      },
      {
        title: "Loan",
        path: "/loan/list",
      },
      {
        title: "Loan Return",
        path: "/loan/return",
      },
      {
        title: "Loan Profit",
        path: "/loan/profit",
      },
    ],
  },
  {
    title: "DPS",
    icon: <IconWallet stroke={1.5} size={20} />,
    children: [
      {
        title: "DPS Person",
        path: "/dps/person",
      },
      {
        title: "DPS",
        path: "/dps/list",
      },
      {
        title: "DPS Withdraw",
        path: "/dps/withdraw",
      },
      {
        title: "DPS Profit",
        path: "/dps/profit",
      },
    ],
  },
  {
    title: "Qard al-Hasana",
    icon: <IconCreditCard stroke={1.5} size={20} />,
    children: [
      {
        title: "Qard al-Hasana List",
        path: "/karjo/list",
      },
      {
        title: "Giving",
        path: "/karjo/giving",
      },
      {
        title: "Giving Return",
        path: "/karjo/return-giving",
      },
      {
        title: "Taking",
        path: "/karjo/taking",
      },
      {
        title: "Taking Return",
        path: "/karjo/return-taking",
      },
    ],
  },
  {
    title: "Expense",
    icon: <IconChartPie stroke={1.5} size={20} />,
    children: [
      {
        title: "Category",
        path: "/expense/category",
      },
      {
        title: "Expense",
        path: "/expense/list",
      },
      {
        title: "Report Category",
        path: "/expense/report-category",
      },
    ],
  },
  {
    title: "Neptune Cutting",
    icon: <IconCut stroke={1.5} size={20} />,
    children: [
      {
        title: "Investment",
        path: "/cutting/investment",
      },
      {
        title: "Investment Return",
        path: "/cutting/return-investment",
      },
      {
        title: "Report",
        path: "/cutting/report",
      },
    ],
  },
  {
    title: "Neptune Traders",
    icon: <IconBuilding stroke={1.5} size={20} />,
    children: [
      {
        title: "Investment",
        path: "/traders/investment",
      },
      {
        title: "Investment Return",
        path: "/traders/return-investment",
      },
      {
        title: "Report",
        path: "/traders/report",
      },
    ],
  },
  {
    title: "Investment",
    icon: <IconCash stroke={1.5} size={20} />,
    children: [
      {
        title: "Investment",
        path: "/investment/list",
      },
      {
        title: "Investment Records",
        path: "/investment/return-records",
      },
    ],
  },
  {
    title: "Staff",
    icon: <IconUserCheck stroke={1.5} size={20} />,
    children: [
      {
        title: "Staff List",
        path: "/staff/list",
      },
      {
        title: "Payment Category",
        path: "/staff/payment-category",
      },
      {
        title: "Payments",
        path: "/staff/payments",
      },
    ],
  },
  {
    title: "Advance",
    icon: <IconWallet stroke={1.5} size={20} />,
    children: [
      {
        title: "Advance",
        path: "/advance/list",
      },
      {
        title: "Return Records",
        path: "/advance/return-records",
      },
    ],
  },
  {
    title: "Others Income",
    icon: <IconZoomMoney stroke={1.5} size={20} />,
    children: [
      {
        title: "Category",
        path: "/others-income/category",
      },
      {
        title: "Others Income",
        path: "/others-income/list",
      },
      {
        title: "Category Report",
        path: "/others-income/report/category",
      },
    ],
  },
  {
    title: "SMS",
    icon: <IconSend stroke={1.5} size={20} />,
    children: [
      {
        title: "Selected Person",
        path: "/sms/selected-person",
      },
      {
        title: "All Person",
        path: "/sms/all-persons",
      },
    ],
  },
];

export default navConfig;
